import { SpaceActionButton, SpaceEmbedCodeAction } from "@components/space-actions";
import { Embed as EmbedIcon } from "@piiqtechnologies/svg-icons";
import React from "react";
import { useIntl } from "react-intl";
import messages from "../messages.i18n";
export const UnitSpaceEmbedCodeAction = ({ spaceDetails }) => {
    const intl = useIntl();
    return (React.createElement(SpaceEmbedCodeAction, { spaceId: spaceDetails._id, EmbedCodeComponent: ({ onEmbedCode }) => (React.createElement(SpaceActionButton, { "aria-label": "Embed Code", Icon: EmbedIcon, iconSize: 14, tooltip: intl.formatMessage(messages.actionsEmbedCode), onClick: onEmbedCode, disabled: !spaceDetails.isComplete })) }));
};
export default UnitSpaceEmbedCodeAction;
